
export const containerClasses =
    "min-h-screen bg-gray-50 px-4 sm:px-6 pt-8 pb-12";

export const sectionTitleClasses =
    "text-2xl font-semibold text-gray-800 mb-4";

export const pageTitleClasses =
    "text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center";

export const gridClasses =
    "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6";

export const cardClasses =
    "bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition p-6";

export const primaryBtnClasses =
    "inline-flex justify-center items-center px-4 py-2 text-sm font-medium rounded-lg bg-blue-600 text-white hover:bg-blue-700";

export const secondaryBtnClasses =
    "inline-flex justify-center items-center px-4 py-2 text-sm font-medium rounded-lg bg-gray-100 text-gray-800 hover:bg-gray-200";

export const primaryBtnModernClasses =
    "inline-flex items-center justify-center gap-2 rounded-2xl bg-[#c96d3b] px-5 py-3 text-sm font-semibold text-white shadow-[0_14px_35px_rgba(201,109,59,0.28)] transition hover:-translate-y-0.5 hover:bg-[#b85d2c] hover:shadow-[0_18px_45px_rgba(201,109,59,0.34)]";

export const secondaryBtnModernClasses =
    "inline-flex items-center justify-center gap-2 rounded-2xl border border-[#d9ccb8] bg-[#fffaf3] px-5 py-3 text-sm font-semibold text-[#34566a] shadow-sm transition hover:-translate-y-0.5 hover:border-[#cbb89a] hover:bg-white";

